import React from 'react';
import {Link} from 'react-router-dom';
import {CogIcon, DocumentIcon, HomeIcon, CalendarDateRangeIcon} from '@heroicons/react/24/solid';
import useStore from './UseStore';

const NavBarLeft = () => {
    const {activePath, setActivePath} = useStore();

    const menuItems = [
        {path: '/', label: 'Dashboard', icon: HomeIcon},
        {path: '/reports', label: 'Einzelbericht', icon: DocumentIcon},
        {path: '/future-projects', label: 'Zukünftige Projekte', icon: CalendarDateRangeIcon},
        {path: '/settings', label: 'Einstellungen', icon: CogIcon},
    ];

    const handleLogoClick = () => {
        window.open('https://www.hch-umwelt.de/', '_blank');
    };

    return (
        <main className='w-full h-screen flex flex-col bg-color-3'>
            <div className='flex items-center h-16 pl-8 border-b border-color-1'>
                <h2 className='font-bold font-color-1 text-sm'>HCH Umwelt GmbH</h2>
            </div>

            {/* Menüinhalt mit flexiblem Raum */}
            <div className='flex flex-col flex-grow p-8 space-y-4'>
                <h3 className='text-sm font-color-2'>MENU</h3>
                {menuItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`flex items-center space-x-2 rounded-lg p-2 font-semibold text-sm ${
                            activePath === item.path ? 'bg-color-2 font-color-1 ' : 'font-color-2'
                        }`}
                        onClick={() => setActivePath(item.path)}
                    >
                        <item.icon
                            className={`h-5 w-5 ${activePath === item.path ? 'font-color-1 ml-4' : 'font-color-2'}`}/>
                        <span>{item.label}</span>
                    </Link>
                ))}
            </div>

            {/* Logo mit Transparenz und Flexibilität am unteren Rand */}
            <div className='flex justify-center mb-16 pb-1'>
                <button onClick={handleLogoClick}>
                    <img
                        src="https://static.wixstatic.com/media/063385_a99eebf06a6b4754b2a5f97f7ce82da9~mv2.png/v1/fill/w_136,h_95,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/063385_a99eebf06a6b4754b2a5f97f7ce82da9~mv2.png"
                        alt="HCH Logo"
                        className="opacity-20 w-28 h-auto" // 50% Transparenz und feste Breite/Höhe
                    />
                </button>
            </div>
        </main>
    );
};

export default NavBarLeft;
